<template>
  <!-- 校本抢课简单选课 -->
  <div class="choseCourse">
    <div class="fl" v-if="list">
      <van-sidebar v-model="activeKey" @change="getIndex">
        <van-sidebar-item
          v-for="item in list"
          :key="item.SubjectGroupID"
          :title="item.SubjectGroupName"
        ></van-sidebar-item>
      </van-sidebar>
    </div>
    <div class="content fr" style="margin-bottom: 65px;" v-if="list" >
      <div class="content-header">
        <!-- <p>{{list[0].SubjectGroupName}}</p> -->
        <p>
          本次最少选
          <span>{{minNum}}</span>门，最多选
          <span>{{maxNum}}</span>门
        </p>
      </div>
      <div class="content-main">
        <div class="course" v-for="item in list[index].Courses" :key="item.AID">
          <div>
            <span>{{item.SubjectName}}</span>
            <img :src="igmUrl" alt />
            <p class="teacher" v-if="item.TeacherName!==''">教师名称：{{item.TeacherName}}</p>
            <p class="current">当前已选：{{item.SelectCount}}/{{item.StudentLimitation}}人</p>
            <div class="btn" v-if="!item.IsSelected" @click="chose(item)">选择</div>
            <div class="btn2" v-if="item.IsSelected" @click="chose(item)">已选</div>
          </div>
        </div>
      </div>
    </div>

    <SingleBottomBtn @clickBtn="complete">完成</SingleBottomBtn>
  </div>
</template>
<script>
import { Notify } from "vant";
const courseUrl = require("@/assets/csmsTimeTable/onlineCourseSelection/course-class-img.png");
import SingleBottomBtn from "@/components/SingleBottomBtn";

export default {
  components: {
    SingleBottomBtn
  },
  data() {
    return {
      igmUrl: courseUrl,
      activeKey: 0,
      index: 0,
      list: [],
      minNum: "",
      maxNum: "",
      crouseList: [],
      accountID: 0,
      ticket: '',
    };
  },
  created() {
    this.getSubjec();
  },
  methods: {
    getIndex(_index) {
      this.index = _index;
    },
    async getSubjec() {
      let res = await this.xyapi.get(
        this.$store.state.apiPath +
          "/api/StudentOnLineSelectCourse/GetSchoolBasedGrabOnLineList",
        {
          classTableID: this.$route.params.classTableID,
          isShow: false,
          studentID: 0
        }
      );
      if (res.success) {
        if (res.data.Results.length) {
          this.crouseList = res.data
          this.list = res.data.Results;
          this.minNum = res.data.MinOptionalCourse;
          this.maxNum = res.data.MaxOptionalCourse;
          this.accountID = res.data.AccountID
        }
      }
    },
    async chose(i) {
      if (i.IsChoice) {
        if (!i.IsSelected) {// 选中
          let res1 = await this.xyapi.get(`${this.xyMApi}/generate/api/Generate/Generate`, {
            accountID: this.accountID,
            classTableID: this.$route.params.classTableID,
            aid: i.SelectCourseAID,
            studentID: i.SubjectID,
            studentOrganizationID: i.StudentOrganizationID
          })
          if (res1.success) {
            this.ticket = res1.data
            let res = await this.xyapi.post(
            this.$store.state.apiPath + "/api/StudentOnLineSelectCourse/SchoolBasedGrabSelect", {
              ClassTableID: this.$route.params.classTableID,
              AID: i.AID,
              CoursePlanID: i.CoursePlanID,
              Type: i.Type,
              SelectAID: i.SelectiveAID,
              // SelectiveCourse: i.SelectiveCourse,
              SelectType: i.SelectiveType,
              StudentID: i.SubjectID,
              ticket: this.ticket
            });
            if (res.success) {
              this.getSubjec();
            } else {
              // 选择失败后释放名额
              let resRemove = await this.xyapi.get(`${this.xyMApi}/generate/api/Generate/Remove`, {
                accountID: this.accountID,
                classTableID: this.$route.params.classTableID,
                aid: i.SelectCourseAID,
                studentID: i.SubjectID,
                studentOrganizationID: i.StudentOrganizationID
              })
              if (resRemove.success) {
                //
              }
            }
          }
        } else {//取消选中
          let res1 = await this.xyapi.get(`${this.xyMApi}/generate/api/Generate/Remove`, {
            accountID: this.accountID,
            classTableID: this.$route.params.classTableID,
            aid: i.SelectCourseAID,
            studentID: i.SubjectID,
            studentOrganizationID: i.StudentOrganizationID
          })
          if (res1.success) {
            this.ticket = res1.data
            let res = await this.xyapi.post(
            this.$store.state.apiPath + "/api/StudentOnLineSelectCourse/SchoolBasedGrabUnSelect",{
              ClassTableID: this.$route.params.classTableID,
              AID: i.AID,
              CoursePlanID: i.CoursePlanID,
              Type: i.Type,
              SelectAID: i.SelectiveAID,
              // SelectiveCourse: i.SelectiveCourse,
              SelectType: i.SelectiveType,
              StudentID: i.SubjectID,
              ticket: this.ticket
            });
            if (res.success) {
              this.getSubjec();
            }
          }
        }
      }
    },
    async complete() {
      if (this.crouseList.SelfSelectCount > this.crouseList.MaxOptionalCourse) {
        Notify({
          type: "danger",
          message: "最多选择" + this.crouseList.MaxOptionalCourse + "门"
        });
        return false;
      }
      if (this.crouseList.SelfSelectCount < this.crouseList.MinOptionalCourse) {
        Notify({
          type: "danger",
          message: "请至少选择" + this.crouseList.MinOptionalCourse + "门"
        });
        return false;
      }
      for (var i = 0; i < this.crouseList.Results.length; i++) {
        if (
          this.crouseList.Results[i].SelectNum >
          this.crouseList.Results[i].MaxSubjectNum
        ) {
          Notify({
            type: "danger",
            message:
              this.crouseList.Results[i].SubjectGroupName +
              "最多选择" +
              this.crouseList.Results[i].MaxSubjectNum +
              "门"
          });
          return false;
        }
        if (
          this.crouseList.Results[i].SelectNum <
          this.crouseList.Results[i].MinSubjectNum
        ) {
          Notify({
            type: "danger",
            message:
              this.crouseList.Results[i].SubjectGroupName +
              "请至少选择" +
              this.crouseList.Results[i].MinSubjectNum +
              "门"
          });
          return false;
        }
      }
      let res = await this.xyapi.post(
        this.$store.state.apiPath +
          "/api/StudentOnLineSelectCourse/SchoolBasedGrabCompleteSelectCourse",
        {
          ClassTableID: this.$route.params.classTableID,
          StudentID: 0,
          CollectionID: this.$route.params.CollectionID
        }
      );
      if (res.success) {
        this.$router.push(`/home/onlineChoseClass`);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.choseCourse {
  width: 100%;
  .van-sidebar-item--select {
    color: #323233;
    font-weight: 500;
    border-color: #4196ff;
  }
  .van-sidebar-item {
    border-bottom: 1px solid #e6e6e6;
    line-height: inherit;
  }
  .fl {
    width: 20%;
    background: rgba(249, 249, 249, 1);
    box-shadow: 0px 4px 8px 0px rgba(151, 151, 151, 0.2);
  }
  .fr {
    width: 78%;
    margin: 10px auto;
  }
  .content {
    background-color: #fff;
    .content-header {
      padding: 15px 0 20px 20px;
      height: 100px;
      width: 100%;
      background-image: url("./../../../../assets/csmsTimeTable/onlineCourseSelection/conheader.png");
      background-size: cover;
      line-height: 35px;
      p:nth-child(1) {
        font-size: 26px;
        color: rgba(51, 51, 51, 1);
      }
      p:nth-child(2) {
        font-size: 22px;
        color: rgba(153, 153, 153, 1);
      }
      p {
        span {
          color: #545efa;
          font-weight: bold;
        }
      }
    }
    .content-main {
      text-align: center;
      p:nth-child(1) {
        font-size: 28px;
        color: #1d2157;
        font-weight: bold;
      }
      p:nth-child(2) {
        font-size: 22px;
        color: rgba(153, 153, 153, 1);
        line-height: 35px;
      }
      p {
        span {
          color: #545efa;
          font-weight: bold;
        }
      }
      .course {
        padding-left: 30px;
        margin-top: 20px;
        padding-top: 25px;
        border-top: 1px solid #e6e6e6;
        // border-bottom: 1px solid #e6e6e6;
        div {
          position: relative;
          height: 150px;
          span {
            float: left;
          }
          img {
            position: absolute;
            width: 58px;
            height: 64px;
            left: 0;
            top: 25%;
          }
          .teacher {
            position: absolute;
            left: 20%;
            top: 30%;
            font-size: 22px;
            text-align: left;
            font-weight: normal;
            color: #999999;
          }
          .current {
            position: absolute;
            left: 20%;
            top: 50%;
            font-size: 22px;
            text-align: left;
            font-weight: normal;
            color: #999999;
          }
          .btn {
            position: absolute;
            right: 5%;
            top: 25%;
            width: 124px;
            height: 52px;
            border: 1px solid rgba(255, 149, 0, 1);
            box-shadow: 0px 4px 8px 0px rgba(228, 111, 86, 0.5);
            border-radius: 26px;
            line-height: 52px;
            text-align: center;
            font-weight: normal;
            font-size: 24px;
            font-weight: 400;
            color: rgba(246, 141, 5, 1);
          }
          .btn2 {
            position: absolute;
            right: 5%;
            top: 25%;
            width: 124px;
            height: 52px;
            background: rgba(255, 149, 0, 1);
            box-shadow: 0px 4px 8px 0px rgba(228, 111, 86, 0.5);
            border-radius: 26px;
            line-height: 52px;
            text-align: center;
            font-weight: normal;
            font-size: 24px;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>